export const OPEN_ADD_PARISH_EVENT: string = 'todai-app.open-add-parish';
